import swal from "sweetalert2";
import AdminApi from '../../services/api'
import OpenApi from "../../services/openApi";
const AdminApiService = new AdminApi()
const OpenApiService = new OpenApi()
const mapCourier = require('../../assets/img/icon_courier.png');

export default {
    data() {
        return {
            orderId : "",
            calledFunc: null,
            map: null,
            courierMarker: null,
            companyMarker: null
        }
    },
    methods: {
        getOrder: getOrder,
        initMap: initMap,
        listenOrdersData: listenOrdersData,
    },
    beforeDestroy() {
        if(this.calledFunc != null){
            clearTimeout(this.calledFunc);
            this.calledFunc = null;
        }
    },
    beforeMount() {
        let mapScript1 = document.createElement('script')
        mapScript1.setAttribute('src', 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.js')
        mapScript1.setAttribute('integrity', 'sha256-20nQCchB9co0qIjJZRGuk2/Z9VM+kNiyxNV1lvTlZBo=')
        mapScript1.setAttribute('crossorigin', '')
        document.head.appendChild(mapScript1)

        let cssMap1 = document.createElement('link')
        cssMap1.setAttribute('rel', 'stylesheet')
        cssMap1.setAttribute('href', 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.css')
        cssMap1.setAttribute('integrity', 'sha256-p4NxAoJBhIIN+hmNHrzRCf9tD/miZyoHS5obTRR9BMY=')
        cssMap1.setAttribute('crossorigin', '')
        document.head.appendChild(cssMap1)


        if(this.$route.query.orderId != null){
            this.orderId = this.$route.query.orderId
        }
        this.listenOrdersData();
    },
    watch: {

    }
}

function listenOrdersData() {
    let _self = this;
    _self.getOrder();
    if(_self.calledFunc != null){
        clearTimeout(_self.calledFunc);
    }
    _self.calledFunc = setTimeout(function(){ _self.listenOrdersData(); }, 30000);
}

function getOrder(){
    if(this.orderId == null || this.orderId.length === 0) return
    let _self = this;
    OpenApiService.getOrder(this.orderId)
        .then((response) => {
            if(response.data.status === "DELIVERED"){
                if(_self.calledFunc != null){
                    clearTimeout(_self.calledFunc);
                    _self.calledFunc = null;
                }
                swal('Success', "Order is delivered to customer :)", 'success')
            }else if(response.data.status !== "PICKED_UP"){
                swal('Info', "Order can be tracked when courier take the order.", 'info')
            }else{
                _self.initMap(response.data)
            }
        })
        .catch((error) => {
            console.log(error)
            swal('Info', "Order can be tracked when courier take the order.", 'info')
        })
}

function initMap(order){
    // console.log(L.DomUtil)
    // var container = L.DomUtil.get('map');
    // if(container != null){
    //     container._leaflet_id = null;
    // }
    if(this.map == null){
        let mapOptions = {
            center:[order.address.lat, order.address.lng],
            zoom:14
        }

         this.map = new L.map('map' , mapOptions);
    }else{
        this.map.removeLayer(this.courierMarker);
        this.map.removeLayer(this.companyMarker);
    }


    let layer = new L.TileLayer('http://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png');
    this.map.addLayer(layer);

    this.companyMarker = new L.Marker([order.address.lat, order.address.lng]);
    this.companyMarker.addTo(this.map);

    //courier
    let customIcon = {
        iconUrl: mapCourier,
        iconSize:[40,40]
    }
    let myIcon = L.icon(customIcon);

    let iconOptions = {
        title:"Courier",
        draggable:false,
        icon:myIcon
    }

    this.courierMarker = new L.Marker([order.courier.position.lat, order.courier.position.lng], iconOptions);
    this.courierMarker.addTo(this.map);
}



// WEBPACK FOOTER //
// ./src/components/Map/TrackingFree.js